import script from "./GlobalAdminList.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAdminList.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAdminList.vue?vue&type=style&index=0&id=55ae34df&lang=css"

const __exports__ = script;

export default __exports__